import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-contract-transfer',
    templateUrl: './dialog-contract-transfer.component.html',
    styleUrls: ['./dialog-contract-transfer.component.scss'],
    standalone: false
})
export class DialogContractTransfer implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogContractTransfer>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {
  }

  onClick(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }


}
